import { CustomSectionState } from 'api/custom-section/types';
import { FC, useState } from 'react';
import { CompanyPageSourceDerivedSectionPromptInput } from './prompt-input';
import { CompanyPageSourceDerivedSectionPromptPreview } from './prompt-preview';
import { CompanyPageSourceDerivedSectionComponentProps } from '../types';

export const CompanyPageSourceDerivedSectionPrompt: FC<
  CompanyPageSourceDerivedSectionComponentProps
> = (props) => {
  const [isEditing, setIsEditing] = useState(
    props.node.attrs.state === CustomSectionState.Open,
  );

  return (
    <div>
      {isEditing ? (
        <CompanyPageSourceDerivedSectionPromptInput
          {...props}
          onEditDone={() => {
            setIsEditing(false);
          }}
        />
      ) : (
        <CompanyPageSourceDerivedSectionPromptPreview
          {...props}
          onWrapperClick={() => {
            setIsEditing(true);
          }}
        />
      )}
    </div>
  );
};
